module.exports = __webpack_public_path__ + "img/w4-cover.0e51c631.jpg";